import Vue from 'vue'
import axios from 'axios'
import CryptoJS from './aes'
import Router from 'vue-router'
import router from '../router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
const aesKey = 'baijipcjingcai'
Vue.use(Router)
// export const API_URL = process.env.BASE_URI
// export const API_URL = './api' // 测试 
export const API_URL = 'https://baijihongan.com/api/v1/' //正式

/**
 * md5 加密
 * @param  string str 要加密的数据
 * @return string
 */
function md5(str) {
    return CryptoJS.MD5(str).toString();
}

/**
 * aes 加密
 * @param  string str 要加密的数据
 * @return string
 */
function aesEncrypt(str) {
    var encryptKey = CryptoJS.enc.Utf8.parse(md5(aesKey));
    var iv = CryptoJS.enc.Utf8.parse(md5(aesKey).substr(0, 16));
    var encrypted = CryptoJS.AES.encrypt(str, encryptKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

/**
 * aes 解密
 * @param  string str 要解密的数据
 * @return string
 */
function aesDecrypt(str) {
    var encryptKey = CryptoJS.enc.Utf8.parse(md5(aesKey));
    var iv = CryptoJS.enc.Utf8.parse(md5(aesKey).substr(0, 16));
    var decrypted = CryptoJS.AES.decrypt(str, encryptKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypted);
}

/**
 * 格式化参数对象，按键值自然排序
 * @param  object data 参数对象
 * @return string
 */
function formatParam(data) {
    var key = Object.keys(data).sort();
    var arr = [];
    for (var i = 0; i < key.length; i++) {
        arr.push(key[i] + '=' + data[key[i]]);
    }
    return arr.join('&');
}

/**
 * 生成 sign 签名
 */
function setSign() {
    var data = typeof (arguments[0]) != 'undefined' ? arguments[0] : new Object();
    data.aesKey = md5(aesKey);
    data.timestamp = (new Date()).getTime() + (Math.random() * 1000).toFixed(0);
    var param = formatParam(data);
    // console.log(param)
    return aesEncrypt(param);
}



/**
 * 网络请求封装
 * @param url url路径名 例：/books
 * @param data 请求参数 string类型
 */
const ajax = (url, data, isLoading = true) => {
    // const inputData = Object.assign({}, data, encryption(data));
    var locationUrl = window.location.hash.split("#/")[1];
    locationUrl = locationUrl.split("?")
    
    // data.menu = '/'+locationUrl[0]
    let _this = this
    return new Promise((resolve, reject) => {
        axios.post(API_URL + url, data, {
            headers: {  //头部参数
                signature: setSign()
            }
        }).then(function (response) {
            if(response.data.status=='-888'){
                router.push('/404')
            }else if(response.data.status=='-999'){
				_this.$message.error("身份过期，请重新登录");
                router.push('/login')
            }
            else{
                resolve(response.data);
            }
            
        }).catch(function (error) {
            
            // _this.$message(error);
        });
    });
}
// 签名
function encryption(data) {
    let queryStr = '';
    let timestamp = (new Date().getTime()).toString();
    let key = md5(aesKey);

    data = data || {};
    data.time = timestamp;
    data.sig_key =md5(aesKey);
    data = ksort(data);
    for (var i in data) {
        queryStr += i + '=' + data[i] + '&';
    }
    // console.log(md5(key.substr(3, key.length) + queryStr.substr(0, queryStr.length - 1) + key.substr(key.length - 5, key.length)))
    return ({
        sig_key: key,
        time: timestamp,
        signature: md5(key.substr(3, key.length) + queryStr.substr(0, queryStr.length - 1) + key.substr(key.length - 5, key.length))
    })
}
// 键排序
function ksort(inputArr) {
    var tmp_arr = {},
        keys = [],
        sorter,
        i,
        k,
        strictForIn = false,
        populateArr = {};

    sorter = function (a, b) {
        var aFloat = parseFloat(a),
            bFloat = parseFloat(b),
            aNumeric = aFloat + '' === a,
            bNumeric = bFloat + '' === b;
        if (aNumeric && bNumeric) {
            return aFloat > bFloat ? 1 : aFloat < bFloat ? -1 : 0;
        } else if (aNumeric && !bNumeric) {
            return 1;
        } else if (!aNumeric && bNumeric) {
            return -1;
        }
        return a > b ? 1 : a < b ? -1 : 0;
    };

    // Make a list of key names
    for (k in inputArr) {
        if (inputArr.hasOwnProperty(k)) {
            keys.push(k);
        }
    }
    keys.sort(sorter);
    // Rebuild array with sorted key names
    for (i = 0; i < keys.length; i++) {
        k = keys[i];
        tmp_arr[k] = inputArr[k];
        if (strictForIn) {
            delete inputArr[k];
        }
    }
    for (i in tmp_arr) {
        if (tmp_arr.hasOwnProperty(i)) {
            populateArr[i] = tmp_arr[i];
        }
    }
    return strictForIn || populateArr;
}
export default ajax;


// WEBPACK FOOTER //
// ./src/utils/ajax.js